import React from 'react';
import './iframe.css';

export const Iframe = ({ title, mediaUrl }) => {
  return (
    <div className='iframe w-full py-8'>
      {mediaUrl && (
        <iframe
          title={title}
          width='100%'
          height='100%'
          src={mediaUrl}
        />
      )}
    </div>
  );
};
